import * as types from '../actionTypes';
// ---- parent imports -----


export function updateIncomeStatementFor(quarterNum, updatedIncomeStatement) {
	return {
		type: types.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER,
		quarterNum,
		updatedIncomeStatement: updatedIncomeStatement
	};
}
